import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

/**
 * Data source for a single instructor invitation detail.
 * Expects params.queryParams.guid or params.filters (column 'guid') to be set.
 */
export function instructor_invitation_detail(componentDataSourceService: ComponentDataSourceService) {
  return {
    name: 'Instruktørinvitation (detalje)',
    description: 'Hent én instruktørinvitation med events, invitees, responses og assignments',
    execute: (params?: LoadDataParams): Observable<any> => {
      const guid = params?.queryParams?.['guid']
        ?? params?.filters?.find((f: any) => f.column === 'guid')?.value
        ?? (params as any)?.guid;
      if (!guid) {
        return of({ items: [], totalCount: 0, invitation: null });
      }
      return componentDataSourceService.http.get<{
        id: number;
        guid: string;
        events: any[];
        invitees: any[];
        responses: any[];
        assignments: any[];
        response_deadline: string;
        status: string;
        [key: string]: any;
      }>(`${environment.apiUrl}/events/instructor-invitations/${guid}`).pipe(
        catchError(error => {
          console.error('Error fetching instructor invitation detail:', error);
          return throwError(() => error);
        }),
        map(invitation => {
          if (!invitation) {
            return { items: [], totalCount: 0, invitation: null };
          }
          return {
            items: invitation.events || [],
            totalCount: (invitation.events || []).length,
            invitation
          };
        })
      );
    },
    settings: {}
  };
}
